<section
  class="py-20 bg-gradient-to-br from-black via-[#1a0a04] to-[#470e03] relative overflow-hidden"
>
  <!-- خلفية تأثيرية -->
  <div class="absolute inset-0 opacity-10">
    <div class="absolute top-0 left-0 w-96 h-96 bg-[#de5806] rounded-full blur-3xl"></div>
    <div class="absolute bottom-0 right-0 w-96 h-96 bg-[#470e03] rounded-full blur-3xl"></div>
    <div
      class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-[#de5806]/70 rounded-full blur-3xl"
    ></div>
  </div>

  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <!-- النص الرئيسي -->
      <div class="space-y-6">
        <div
          class="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full mb-6"
        >
          <i class="fas fa-star text-white w-4 h-4"></i>
          <span class="text-white text-sm">{{ 'home.report.badge' | translate }}</span>
        </div>

        <h2 class="text-white text-4xl font-bold mb-4">{{ 'home.report.title' | translate }}</h2>
        <p class="text-gray-300 mb-8 text-lg leading-relaxed">
          {{ 'home.report.subtitle' | translate }}
        </p>

        <!-- مميزات -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
          <div class="flex items-center gap-3">
            <div
              class="flex-shrink-0 w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center"
            >
              <i class="fas fa-bullseye text-white"></i>
            </div>
            <span class="text-white text-sm">{{ 'home.report.features.reach' | translate }}</span>
          </div>

          <div class="flex items-center gap-3">
            <div
              class="flex-shrink-0 w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center"
            >
              <i class="fas fa-robot text-white"></i>
            </div>
            <span class="text-white text-sm">{{ 'home.report.features.aiTools' | translate }}</span>
          </div>

          <div class="flex items-center gap-3">
            <div
              class="flex-shrink-0 w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center"
            >
              <i class="fas fa-check-circle text-white"></i>
            </div>
            <span class="text-white text-sm">{{
              'home.report.features.management' | translate
            }}</span>
          </div>

          <div class="flex items-center gap-3">
            <div
              class="flex-shrink-0 w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center"
            >
              <i class="fas fa-chart-bar text-white"></i>
            </div>
            <span class="text-white text-sm">{{
              'home.report.features.analytics' | translate
            }}</span>
          </div>
        </div>

        <!-- الأزرار -->
        <!-- <div class="flex flex-col sm:flex-row gap-4">
                              <button
                                    class="group px-8 py-4 bg-gradient-to-r from-[#de5806] to-[#470e03] text-white rounded-xl hover:shadow-xl transition-all shadow-lg flex items-center justify-center gap-2">
                                    <span>Add Your Property for Free</span>
                                    <i class="fas fa-arrow-right group-hover:translate-x-1 transition-transform"></i>
                              </button>
                              <button
                                    class="px-8 py-4 bg-white/10 backdrop-blur-sm text-white border border-white/20 rounded-xl hover:bg-white/20 transition-all">
                                    Learn More
                              </button>
                        </div> -->
      </div>

      <!-- الإحصائيات -->
      <div class="grid grid-cols-2 gap-4">
        <div class="bg-[#404040]/30 backdrop-blur-lg rounded-2xl p-6 border border-[#808080]/30">
          <div class="text-white text-3xl mb-2">12K+</div>
          <div class="text-white/80 text-sm">{{ 'home.report.stats.properties' | translate }}</div>
        </div>
        <div class="bg-[#404040]/30 backdrop-blur-lg rounded-2xl p-6 border border-[#808080]/30">
          <div class="text-white text-3xl mb-2">95%</div>
          <div class="text-white/80 text-sm">{{ 'home.report.stats.bookingRate' | translate }}</div>
        </div>
        <div class="bg-[#404040]/30 backdrop-blur-lg rounded-2xl p-6 border border-[#808080]/30">
          <div class="text-white text-3xl mb-2">7 Days</div>
          <div class="text-white/80 text-sm">{{ 'home.report.stats.avgTime' | translate }}</div>
        </div>
        <div class="bg-[#404040]/30 backdrop-blur-lg rounded-2xl p-6 border border-[#808080]/30">
          <div class="text-white text-3xl mb-2">50K+</div>
          <div class="text-white/80 text-sm">{{ 'home.report.stats.visits' | translate }}</div>
        </div>

        <div
          class="col-span-2 bg-gradient-to-br from-[#404040]/40 to-[#808080]/20 backdrop-blur-lg rounded-2xl p-6 border border-[#bfbfbf]/30"
        >
          <div class="flex items-center gap-3 mb-3">
            <div class="w-12 h-12 bg-white rounded-xl flex items-center justify-center">
              <i class="fas fa-robot text-black text-lg"></i>
            </div>
            <div>
              <div class="text-white">{{ 'home.report.stats.aiTools.title' | translate }}</div>
              <div class="text-white/60 text-sm">
                {{ 'home.report.stats.aiTools.description' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
